import React from 'react';
import { FileX2 } from 'lucide-react';
import { T } from '../../lib/designTokens';
import { AUFZUHEBENDE_VERTRAEGE, KUENDIGUNGSGRUNDLAGEN, vertragsendeVollstaendig } from '../../lib/aufhebung';

const FELD_STIL = { width: '100%', minHeight: 30, padding: '6px 8px', border: '1px solid #CBD5E1', borderRadius: 7, fontSize: 11, color: '#0F172A', background: '#FFFFFF' };
const LABEL_STIL = { display: 'flex', flexDirection: 'column', gap: 4, fontSize: 10.5, color: T.muted };

/**
 * Angaben zum beendeten Vertrag (Aufhebungsvereinbarung oder Kündigung). Sie
 * stehen in keinem Bitrix-Feld; die Vertragsart schlägt der Server aus dem
 * Deal vor. Bei der Kündigung hängt die Klausel an der Vertragsart – dort gibt
 * es keine freie Bezeichnung, dafür das Briefdatum.
 *
 * @param {{
 *   vertragKey: string,
 *   angaben: { vertrag: string, datum: string, briefdatum: string },
 *   onAendern: (feld: 'vertrag' | 'datum' | 'briefdatum', wert: string) => void,
 *   vorschlagHinweis?: string,
 *   istKuendigung?: boolean,
 * }} props
 */
export default function AufhebungAngaben({ vertragKey, angaben, onAendern, vorschlagHinweis = '', istKuendigung = false }) {
  const vollstaendig = vertragsendeVollstaendig(vertragKey, angaben);
  const auswahl = istKuendigung
    ? AUFZUHEBENDE_VERTRAEGE.filter((v) => KUENDIGUNGSGRUNDLAGEN[v.key])
    : AUFZUHEBENDE_VERTRAEGE;
  const bekannt = auswahl.some((v) => v.label === angaben.vertrag);
  const freieBezeichnung = !istKuendigung && !bekannt && Boolean(angaben.vertrag);
  const standardHinweis = istKuendigung
    ? 'Steht in keinem Bitrix-Feld. Die Klausel ergibt sich aus der Vertragsart. Versand per Einwurf-Einschreiben.'
    : 'Steht in keinem Bitrix-Feld. Ohne beide Angaben wird nichts hochgeladen.';
  return (
    <div style={{ marginTop: 10, border: '1px solid #D7E2F1', borderRadius: 8, background: '#FFFFFF', overflow: 'hidden' }}>
      <div style={{ padding: '8px 10px', borderBottom: '1px solid #E2E8F0', display: 'flex', alignItems: 'center', gap: 6, color: '#122A5C', fontSize: 11, fontWeight: 700 }}>
        <FileX2 size={13} />
        {istKuendigung ? 'Gekündigter Vertrag' : 'Aufzuhebender Vertrag'}
        <span style={{ marginLeft: 'auto', color: vollstaendig ? '#0F766E' : '#B45309', fontSize: 10, fontWeight: 700 }}>
          {vollstaendig ? 'vollständig' : 'offen'}
        </span>
      </div>
      <div style={{ padding: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <label style={LABEL_STIL}>
          Vertragsart
          <select
            value={freieBezeichnung ? '__eigen' : (bekannt ? angaben.vertrag : '')}
            onChange={(event) => onAendern('vertrag', event.target.value === '__eigen' ? ' ' : event.target.value)}
            style={{ ...FELD_STIL, minHeight: 32 }}
          >
            <option value="">Bitte wählen …</option>
            {auswahl.map((v) => (
              <option key={v.key} value={v.label}>{v.label}</option>
            ))}
            {istKuendigung ? null : <option value="__eigen">Andere Bezeichnung …</option>}
          </select>
        </label>
        {freieBezeichnung ? (
          <input
            value={angaben.vertrag.trimStart()}
            onChange={(event) => onAendern('vertrag', event.target.value)}
            placeholder="z. B. Nutzungsvertrag Dachfläche"
            aria-label="Bezeichnung des aufzuhebenden Vertrags"
            style={FELD_STIL}
          />
        ) : null}
        <label style={LABEL_STIL}>
          Vertragsdatum
          <input type="date" value={angaben.datum} onChange={(event) => onAendern('datum', event.target.value)} style={FELD_STIL} />
        </label>
        {istKuendigung ? (
          <label style={LABEL_STIL}>
            Briefdatum
            <input type="date" value={angaben.briefdatum} onChange={(event) => onAendern('briefdatum', event.target.value)} style={FELD_STIL} />
          </label>
        ) : null}
        <div style={{ color: T.muted, fontSize: 10.5, lineHeight: 1.35 }}>
          {vorschlagHinweis || standardHinweis}
        </div>
      </div>
    </div>
  );
}
